// src/modules/app-views/_apps/appsindico/unitProfiles/pages/Init/components/tableColumns/nameColumn.jsx
// *******************************************************************************
// NAME COLUMN
// *******************************************************************************

import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function nameColumn(buildColumnProps, options = {}) {
  const {
    key = 'name',
    title = 'name',
    dataIndex = 'name',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...buildColumnProps(dataIndex, columnProps),
    render: text => text || '-',
  };
}

export default nameColumn;
